import React, { useContext, useEffect } from 'react';
import { Button, Form, Spinner, Table } from 'react-bootstrap';
import { MdFileCopy, MdEditSquare, MdDelete } from 'react-icons/md'
import { Link, useNavigate } from 'react-router-dom';
import Zoom from 'react-medium-image-zoom';
import DataTable from 'react-data-table-component';
import moment from 'moment';

import { get_history_data } from '../../Controller/actions';
import { NewContext } from '../../Context/NewContext';
import PaginationCmp from '../../Components/Pagination/PaginationCmp';
import PopOver from '../../Components/Popover/PopOver';
import { Header } from '../../Components/Header';
import { THead } from '../../Components/Table';

import './history.css';

export const History = ({ title }) => {
    const navigate = useNavigate();
    const { filterDropdown, currentTableData, setCurrentTableData, currentPage, setCurrentPage, totalPage, setTotalPage, perPage, setPerPage, isLoading, setIsLoading, confirmationModalShow, setConfirmationModalShow, deleteUpdateTag, setDeleteUpdateItem, search, setDeleteUpdateYes, checkedValues, handleCopyData, handleCheckboxChange } = useContext(NewContext);
    // const simpleFields = [
    //     { name: "Id", selector: row => row.id, sortable: true },
    //     { name: "Name", selector: row => row.name, sortable: true },
    //     { name: "Preview", selector: row => <img className="mt-1" src={row.preview} width="30%" alt="MDN logo" /> },
    //     { name: "Link", selector: row => row.link },
    //     { name: "Orientation", selector: row => row.orientation },
    //     { name: "From_Flg", selector: row => row.from_flg },
    //     { name: "SliderTag", selector: row => row.sliderTag },
    // ];
    const simpleFields = ["Id", "Section", "Data Id", "Old Data", "New Data", "Update By", "Updated At"]
    const dropdownFields = [];
    const totalFields = simpleFields.length + dropdownFields.length + 2;

    const getSliderData = async (_currentPage = 1) => {
        setIsLoading(true);
        try {
            const getSliders = await get_history_data(_currentPage, perPage, search, filterDropdown);
            if (getSliders) {
                const { status, data, message, currentPage, perPage, totalPage } = getSliders;
                if (status) {
                    // console.log(status, data, message);
                    // setSlidersData(data);
                    // const newData = data.map((_ele, i) => ({ ..._ele, id: perPage * (currentPage - 1) + (i + 1) }))
                    // console.log(data);
                    setCurrentTableData(data);
                    setCurrentPage(currentPage);
                    setPerPage(perPage);
                    setTotalPage(totalPage);
                } else {
                    setCurrentTableData([]);
                }
            }
            setIsLoading(false);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getSliderData(currentPage);
    }, [deleteUpdateTag, search, filterDropdown]);

    useEffect(() => {
        document.title = `Emoji Keyboard | ${title}`
    }, []);

    return (
        <div className='updated-history-header-main ms-auto p-3'>
            <Header title={`History`} previewLink={`/preview`} deleteUpdateTag={"alldeletehistory"} />
            <Table striped bordered hover responsive>
                <THead
                    simpleFields={simpleFields}
                    dropdownFields={dropdownFields}
                    actionField={false}
                />
                <tbody>
                    {
                        isLoading ?
                            <tr>
                                <td colSpan={totalFields} className='py-5'>
                                    <div className="d-flex justify-content-center align-items-center">
                                        <Spinner animation="border" />
                                    </div>
                                </td>
                            </tr>
                            : currentTableData.length === 0 ?
                                <tr>
                                    <td colSpan={totalFields} className='py-5 bg-light'>
                                        <div className="d-flex justify-content-center align-items-center">
                                            No Data Found
                                        </div>
                                    </td>
                                </tr>
                                :
                                currentTableData.map((_ele, i) => (
                                    <tr key={i} className="align-middle">
                                        <td>
                                            <Form.Check
                                                type={'checkbox'}
                                                id={`slider-${_ele._id}`}
                                                value={`${_ele._id}`}
                                                checked={checkedValues.includes(`${_ele._id}`)}
                                                onChange={() => handleCheckboxChange(`${_ele._id}`)}
                                                className='item-checkbox'
                                            />
                                        </td>
                                        <td>{perPage * (currentPage - 1) + (i + 1)}</td>
                                        <td>{_ele.section ? _ele.section : <span className='text-muted'>None</span>}</td>
                                        <td>{_ele.id ? _ele.id : <span className='text-muted'>None</span>}</td>
                                        <td className='position-relative'>
                                            {
                                                _ele?.oldData && Object?.keys(_ele?.oldData)?.length ? Object?.keys(_ele?.oldData).map((_key, i) => {
                                                    if (_ele.oldData[_key].toString().includes('http://192.168.1.162:8000')) {
                                                        return <p key={i} className='py-1 text-danger text-truncate'>{_key} : {_ele.oldData[_key].toString().split('/').slice(-1).join('/')}</p>
                                                    } else {
                                                        return <p key={i} className='py-1 text-danger text-truncate'>{_key} : {_ele.oldData[_key].toString()}</p>
                                                    }
                                                }) : <span className='text-muted'>None</span>}</td>
                                        <td className='position-relative'>
                                            {
                                                _ele?.newData && Object?.keys(_ele?.newData)?.length ? Object?.keys(_ele?.newData).map((_key, i) => {
                                                    if (_ele.newData[_key].toString().includes('http://192.168.1.162:8000')) {
                                                        return <p key={i} className='py-1 text-success text-truncate'>{_key} : {_ele.newData[_key].toString().split('/').slice(-1)}</p>
                                                    } else {
                                                        return <p key={i} className='py-1 text-success text-truncate'>{_key} : {_ele.newData[_key].toString()}</p>
                                                    }
                                                }) : <span className='text-muted'>None</span>
                                            }
                                        </td>
                                        <td>{_ele?.update_by ? _ele?.update_by.name : <span className='text-muted'>None</span>}</td>
                                        <td>{moment(_ele?.updatedAt).local().format("DD/MM/YYYY, hh:mm A")}</td>
                                    </tr>
                                ))
                    }
                </tbody>
            </Table >
            {/* <DataTable
                columns={simpleFields}
                data={currentTableData}
                selectableRows
            /> */}
            <div className={`table-pagination d-flex justify-content-center justify-content-xl-end ${currentTableData.length > 0 ? 'd-block' : 'd-none'}`}>
                <PaginationCmp
                    currentPage={currentPage}
                    totalPage={totalPage}
                    getData={getSliderData}
                />
            </div >
        </div >
    )
}

export default History;